import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//

import loader from "../components/modals/loader";

export default {
  layout: 'ad',
  components: {
    loader: loader
  },

  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var code, _ref2, user, userId, email, _ref3, idRole;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              code = this.$route.query.code;
              _context.prev = 1;

              this.$refs.loaderModal.showLoader();

              _context.next = 5;
              return this.$store.dispatch("user/getUserAD", { code: code });

            case 5:
              _ref2 = _context.sent;
              user = _ref2.user;
              userId = _ref2.userId;
              email = user.mail;
              _context.next = 11;
              return this.$store.dispatch("user/authLoginAd", {
                email: email,
                userId: userId
              });

            case 11:
              _ref3 = _context.sent;
              idRole = _ref3.idRole;

              this.$refs.loaderModal.closeLoader();

              if (idRole === 5) this.$router.push("/bosses"); // el usuario es administrador de colaboradores
              else this.$router.push("/dashboard");
              _context.next = 22;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](1);

              console.log(_context.t0);
              this.$controlMessage(_context.t0);
              this.$router.push("/");

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this, [[1, 17]]);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/load-ad.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/load-ad.vue
// module chunks = 28